export enum JobStatusEnum {
    QUEUED = 'QUEUED',
    PROCESSING = 'PROCESSING',
    FINISHED = 'FINISHED',
    FAILED = 'FAILED'
}
